import { ReactElement, useState } from 'react'
import { documentationRootGuid } from '@constants'
import { v4 } from 'uuid'
import { Stack, Typography } from '@mui/material'
import { Form } from '@ui/forms'
import { useUploadProjectDocumentationFile } from '@editorHooks'
import FormFields from './components/FormFields'

interface Props {
  itemGuid?: string
  onSuccess?: (newDoc: FileItem) => void
  parentGuid?: string
}

const UploadForm = ({ itemGuid, onSuccess, parentGuid }: Props): ReactElement => {
  const onUploadSuccess = (data: FileItem) => {
    // this forces form to reset
    setFormId(v4())

    onSuccess?.(data)
  }

  const { mutate, isLoading } = useUploadProjectDocumentationFile(
    documentationRootGuid,
    onUploadSuccess,
  )

  const defaultValues: Omit<FileItem, 'guid'> = {
    name: '',
    hierarchy_position: 0,
    element_guid: itemGuid,
    parent_guid: parentGuid || '',
    mimetype: 'application/pdf',
    type: 'file',
  }

  const [formId, setFormId] = useState(v4())

  return (
    <Form
      key={formId}
      onSubmit={data => mutate(data)}
      defaultValues={defaultValues}
      resetIsDirtyAfterSubmit
    >
      <Stack spacing={2}>
        <Typography variant="h5">Neue Datei</Typography>
        <FormFields isLoading={isLoading} />
      </Stack>
    </Form>
  )
}

export default UploadForm
